import React, { useEffect, useState } from "react";
import { Loader2, Plus, Trash2 } from "lucide-react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const Promos = () => {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ code: "", type: "percent", value: 10 });
  const load = () => api.get("/admin/promos").then((r) => { setPromos(r.data); setLoading(false); });
  useEffect(() => { load(); }, []);
  const create = async () => { if (!f.code) return; await api.post("/admin/promos", { ...f, value: Number(f.value) }); toast.success("Code créé"); setF({ code: "", type: "percent", value: 10 }); load(); };
  const del = async (id) => { await api.delete(`/admin/promos/${id}`); load(); };
  if (loading) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-ink mb-8">Codes promotionnels</h1>
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm mb-6 grid gap-3 sm:grid-cols-4 items-end">
        <div><label className="text-sm font-semibold">Code</label><input data-testid="promo-code" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase() })} className="w-full h-12 rounded-xl border-2 border-slate-200 px-3" /></div>
        <div><label className="text-sm font-semibold">Type</label><select value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })} className="w-full h-12 rounded-xl border-2 border-slate-200 px-3"><option value="percent">Pourcentage %</option><option value="fixed">Montant fixe €</option></select></div>
        <div><label className="text-sm font-semibold">Valeur</label><input type="number" value={f.value} onChange={(e) => setF({ ...f, value: e.target.value })} className="w-full h-12 rounded-xl border-2 border-slate-200 px-3" /></div>
        <Button onClick={create} data-testid="save-promo-btn" className="h-12 rounded-full bg-brand text-white font-bold"><Plus className="w-5 h-5 mr-1" /> Créer</Button>
      </div>
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm divide-y divide-slate-50">
        {promos.map((p) => (
          <div key={p.id} className="flex items-center justify-between p-4">
            <div><span className="font-heading font-bold text-lg text-brand">{p.code}</span> <span className="text-ink-muted ml-3">{p.type === "percent" ? `${p.value}%` : `${p.value} €`}</span></div>
            <button onClick={() => del(p.id)} className="text-red-500 hover:text-red-700"><Trash2 className="w-5 h-5" /></button>
          </div>
        ))}
        {promos.length === 0 && <p className="p-6 text-center text-ink-muted">Aucun code promo.</p>}
      </div>
    </div>
  );
};

export default Promos;
